import { IMessage } from '../interfaces/messaging.interface';

export const messages: IMessage[] = [
    {
        id: 1,
        sender: {
            id: '1',
            displayName: 'Robin Desarcy',
        },
        recipients: [
            {
                id: '2',
                displayName: 'John Doe',
            },
            {
                id: '4',
                displayName: 'Marc Aurèle',
            },
        ],
        inCopy: [
            {
                id: '3',
                displayName: 'Jone Doe',
            },
        ],
        subject: 'Email de test',
        message: 'Hello les dev, est-ce que vous recevez bien ce message ?',
        date: new Date(2021, 5, 29),
        important: false,
        attachedFile: [{ file_path: 'https://', name: 'fichier.jpg' }],
        viewed: true,
    },
    {
        id: 2,
        sender: {
            id: '1',
            displayName: 'Robin Desarcy',
        },
        recipients: [
            {
                id: '3',
                displayName: 'Jane Doe',
            },
        ],
        inCopy: [],
        subject: 'Email 2 de test',
        message: 'Hello Robin, est-ce que tu recois bien ce message ?',
        date: new Date(2021, 5, 30),
        important: false,
        attachedFile: [
            { file_path: 'https://', name: 'fichier.jpg' },
            { file_path: 'https://', name: 'image.jpg' },
        ],
        viewed: false,
    },
    {
        id: 3,
        sender: {
            id: '2',
            displayName: 'John Doe',
        },
        recipients: [
            {
                id: '1',
                displayName: 'Robin Desarcy',
            },
        ],
        inCopy: [],
        subject: 'Email 3 de test',
        message: 'Hello Robin, est-ce que tu recois bien ce 3e message ?',
        date: new Date(2021, 5, 21),
        important: true,
        attachedFile: null,
        viewed: true,
    },
    {
        id: 4,
        sender: {
            id: '2',
            displayName: 'John Doe',
        },
        recipients: [
            {
                id: '1',
                displayName: 'Robin Desarcy',
            },
        ],
        inCopy: [],
        subject: 'RE: Email 3 de test',
        message: 'Hello, voici ma reponse ...',
        date: new Date(2021, 5, 28),
        important: true,
        attachedFile: null,
        viewed: true,
    },
];
